import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function ProtectedRoute({ children, allowedRoles = [] }) {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted">
        <div className="flex flex-col items-center gap-4">
          <div className="spinner"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user?.role)) {
    // Redirect to appropriate dashboard based on role
    const dashboardRoutes = {
      agency_admin: '/dashboard/admin',
      ceo: '/dashboard/ceo',
      caregiver: '/dashboard/caregiver',
      client: '/dashboard/client',
      family: '/dashboard/family',
      potential_client: '/browse',
      job_seeker: '/jobs',
      developer: '/dashboard/developer'
    };
    
    const redirectPath = dashboardRoutes[user?.role] || '/';
    return <Navigate to={redirectPath} replace />;
  }

  return children;
}

export default ProtectedRoute;
